/**
 * Created by webstorm
 * User: 小博
 * Date: 2020/3/30
 * Time: 16:47
 *describe: axios二次封装
 */
import Vue from 'vue'
import router from '@/router'
import axios from 'axios'
import { getAccessToken, removeAccessToken } from '@/utils/localStorage'

let alertObj = null
// 创建实例
const requestObj = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

// 创建实例
const requestObjMock = axios.create({
  // baseURL: process.env.VUE_APP_API_BASE_URL
})

// 请求拦截器
requestObj.interceptors.request.use(config => {
  return config
}, err => {
  // 请求错误一般http状态码以4开头，常见：401超时，404 not found
  return Promise.reject(err)
})

// 响应拦截器
requestObj.interceptors.response.use(res => {
  return res
}, err => {
  // 响应错误处理一般http状态码以5开头，常见：500系统错误，502系统重启
  return Promise.reject(err)
})

/**
 * 登录超时提示框
 */
function loginOverdue() {
  alertObj = Vue.prototype.$alert('很抱歉，登录已过期，请重新登录', '登录已过期', {
    confirmButtonText: '重新登录',
    type: 'error',
    callback: () => {
      removeAccessToken()
      router.app.$router.push({
        path: '/user/login',
        query: {
          redirect: router.app.$route.path
        }
      })
    }
  })
}

export function request(settings) {
  let headers = {}
  if (settings.verifyToken) {
    headers = {
      'X-Access-Token': getAccessToken(),
      'Content-Type': settings.isForm ? 'application/x-www-form-urlencoded' : 'application/json; charset=utf-8'
    }
  } else {
    headers = {
      'Content-Type': settings.isForm ? 'application/x-www-form-urlencoded' : 'application/json; charset=utf-8'
    }
  }
  return new Promise((resolve, reject) => {
    requestObj({
      url: settings.url || '',
      method: settings.method || 'get',
      headers,
      data: JSON.stringify(settings.data || {}),
      params: settings.params || {},
      responseType: settings.responseType || 'json'
    }).then((response) => {
      // 登录过期
      if (Number(response.data.msgCode) >= 4010 && Number(response.data.msgCode) <= 4013) {
        reject(response.data.msg)
        if (!alertObj) {
          loginOverdue()
        }
        return
      }
      alertObj = null
      resolve(response.data)
    }).catch(error => {
      reject(new Error(error))
    })
  })
}

export function requestMock(settings) {
  let headers = {}
  if (settings.verifyToken) {
    headers = {
      'token': getAccessToken(),
      'Content-Type': 'application/json; charset=utf-8'
    }
  } else {
    headers = {
      'Content-Type': 'application/json; charset=utf-8'
    }
  }
  return new Promise((resolve, reject) => {
    requestObjMock({
      url: settings.url || '',
      method: settings.method || 'get',
      headers,
      data: JSON.stringify(settings.data || {}),
      params: settings.params || {},
      responseType: settings.responseType || 'json'
    }).then((response) => {
      // 登录过期
      if (response.data.msgCode >= 4010 && response.data.code <= 4013) {
        reject(response.data.msg)
        loginOverdue()
        return
      }
      resolve(response.data)
    })
  })
}
